module.exports = __webpack_public_path__ + "img/Left_arrow_button.1a0996ca.svg";